import { useEffect, useRef } from 'react';
import { useRoute } from '@react-navigation/native';
import type { StockStatusFilter } from '../../stock/public-api';

export type InventoryInitialRouteParams = {
  focusToken?: string;
  initialStockFilter?: StockStatusFilter;
};

type Params = {
  applyStockQuickViewFilter: (next: StockStatusFilter) => void;
};

/**
 * Aplica filtro de estado de stock desde deep link / Home urgencias (una vez por focusToken).
 */
export function useInventoryInitialRouteFilters({ applyStockQuickViewFilter }: Params) {
  const route = useRoute<any>();
  const consumedFocusTokenRef = useRef<string | null>(null);

  useEffect(() => {
    const params = route.params as InventoryInitialRouteParams | undefined;
    const filter = params?.initialStockFilter;
    if (!filter || filter === 'all') return;

    const token = params?.focusToken ?? filter;
    if (token === consumedFocusTokenRef.current) return;
    consumedFocusTokenRef.current = token;

    applyStockQuickViewFilter(filter);
  }, [applyStockQuickViewFilter, route.params]);
}
